import { render, staticRenderFns } from "./BrandSwitcherItem.vue?vue&type=template&id=3b91186a&scoped=true&"
import script from "./BrandSwitcherItem.vue?vue&type=script&lang=js&"
export * from "./BrandSwitcherItem.vue?vue&type=script&lang=js&"
import style0 from "./BrandSwitcherItem.vue?vue&type=style&index=0&id=3b91186a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b91186a",
  null
  
)

export default component.exports